import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    maxWidth: 588,
    width: "100%",
    paddingTop: 20,
    paddingBottom: 24,
    [theme.breakpoints.down("sm")]: {
      padding: "16px 18px"
    }
  },
  header: {
    marginBottom: 16
  },
  title: {
    textAlign: "left",
    lineHeight: "normal"
  },
  buttonsWrapper: {
    maxWidth: 414
  },
  conditionButton: {
    minWidth: 120,
    width: 120,
    height: 40,
    borderRadius: 3,
    border: `1px solid ${theme.palette.text.hint}`,
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    textAlign: "center",
    lineHeight: "normal"
  },
  active: {
    "&&": {
      backgroundColor: theme.palette.secondary.main
    }
  },
  grow: {
    flexGrow: 1
  },
  button: {
    display: "flex",
    alignItems: "center",
    height: 24,
    paddingTop: 4,
    paddingBottom: 4,
    borderRadius: 2,
    borderColor: theme.palette.primary.light,
    paddingLeft: 12,
    paddingRight: 12
  },
  buttonText: {
    fontSize: 12,
    lineHeight: "normal",
    color: theme.palette.text.secondary
  },
  buttonIcon: {
    fontSize: 14,
    color: theme.palette.text.secondary
  },
  notePreview: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 3,
    padding: "12px 14px",
    minHeight: 96,
    wordBreak: "break-word"
  },
  noteValue: {
    fontSize: 14,
    wordBreak: "break-word",
    color: theme.palette.text.primary
  },
  notePlaceholder: {
    color: theme.palette.text.hint
  }
}));
